<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6" sm="8">
          <b-card no-body class="mx-4">
            <b-card-body class="p-4">
              <b-form>
                <h1>Register</h1>
                <p class="text-muted">Create your account</p>

                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text>@</b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input type="text" class="form-control" placeholder="Email" autocomplete="email"  v-model="email"/>
                </b-input-group>

                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text><i class="icon-lock"></i></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input type="password" class="form-control" placeholder="Password" autocomplete="new-password"  v-model="password"/>
                </b-input-group>

                <b-input-group class="mb-4">
                  <b-input-group-prepend>
                    <b-input-group-text><i class="icon-lock"></i></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input type="password" class="form-control" placeholder="Repeat password" autocomplete="new-password" v-model="repassword" />
                </b-input-group>

                <b-button variant="success" @click.prevent="register" >Create Account</b-button>
              </b-form>
              <div class="alert alert-danger" role="alert" v-if="errors.length > 0">
                <ul>
                  <li v-for="error in errors" :key="error">{{error}}</li>
                </ul>

              </div>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Register',
  data () {
    return {
      email: '',
      password: '',
      repassword: '',
      errors: [],
      api_url: ''
    }
  },
  methods: {
    register: function () {
      this.errors = []
      const email = this.email
      const password = this.password
      if (this.password !== this.repassword) {
        this.errors.push('Password do not match')
      }
      if (!this.email) {
        this.errors.push('Email is required')
      }
      if (!this.password) {
        this.errors.push('Password is required')
      }
      if (!this.repassword) {
        this.errors.push('Repassword is required')
      }

      if (this.errors.length === 0) {
        this.$http.post(`${this.api_url}/auth/register`, { email: email, password: password })
          .then((resp) => {
            return this.$router.push('/auth/login')
          })
          .catch(err => {
            console.log(err)
            this.errors = err
          })
      }
    }
  },
  created () {
    this.api_url = this.$api_url
  }
}
</script>
